// Environment configuration
const config = {
  development: {
    API_BASE_URL: 'https://api.scrapsector.in',
    //  API_BASE_URL: 'http://localhost:8080',
    API_TIMEOUT: 10000,
    DEBUG: true,
  },
  production: {
    API_BASE_URL: 'https://api.scrapsector.in',
    // API_BASE_URL: 'http://localhost:8080',
    API_TIMEOUT: 10000,
    DEBUG: false,
  },
  test: {
    API_BASE_URL: 'http://localhost:3001',
    API_TIMEOUT: 5000,
    DEBUG: true,
  }
};

// Get current environment
const environment = process.env.NODE_ENV || 'development';

// Export current config
export default config[environment];

// Export all configs for testing
export { config };
